"use client"

import StoreMap from "@/(admin)/modules/ui-builder/config/themes/tamda-foods/StoreLocator/components/StoreMap"
import { TransformedStoreItem } from "@/(admin)/modules/ui-builder/config/themes/tamda-foods/StoreLocator/types"
import { matchesStoreId } from "@/(admin)/modules/ui-builder/config/themes/tamda-foods/StoreLocator/utils/utils"
import { getFixedT } from "@/languages/i18n"
import { useEffect, useState } from "react"
import ContactInfo from "./ContactInfo"

interface ContactStoreInfoContentProps {
  stores: TransformedStoreItem[]
  title?: string
  initialStoreId?: number
  locale?: string
}

const ContactStoreInfoContent = ({ stores, title, initialStoreId, locale }: ContactStoreInfoContentProps) => {
  const t = getFixedT(locale)
  const [selectedStore, setSelectedStore] = useState<TransformedStoreItem | null>(() => {
    if (initialStoreId) {
      const found = stores.find(s => matchesStoreId(s, initialStoreId))
      return found || (stores.length > 0 ? stores[0] : null)
    }
    return stores.length > 0 ? stores[0] : null
  })

  useEffect(() => {
    if (initialStoreId) {
      const found = stores.find(s => matchesStoreId(s, initialStoreId))
      if (found) {
        setSelectedStore(found)
      }
    } else if (stores.length > 0 && !selectedStore) {
      setSelectedStore(stores[0])
    }
  }, [initialStoreId, stores])

  const handleStoreSelect = (store: TransformedStoreItem) => {
    setSelectedStore(store)
  }

  if (stores.length === 0) {
    return (
      <div className="w-full flex items-center justify-center py-20">
        <p className="text-[14px] leading-[21.7px] text-[#333]">{t("No stores available")}</p>
      </div>
    )
  }

  return (
    <div className="w-full flex flex-col gap-[25px] h-full sm:pt-[68px] pt-[50px] pb-[94px]">
      <h2 className="text-sm sm:text-2xl sm:leading-[37.2px] font-bold leading-[27.9px] text-[#333] uppercase">
        {t("Contact")}
      </h2>

      <div className="flex flex-col sm:flex-row gap-0 h-full border border-[#ced4da] ">
        <div className="w-full sm:w-1/2">
          <ContactInfo store={selectedStore} locale={locale} />
        </div>

        <div className="w-full sm:w-1/2">
          <StoreMap
            stores={stores}
            selectedStore={selectedStore}
            onStoreSelect={handleStoreSelect}
            showMarkers={true}
            className="w-full sm:h-full h-[400px]"
            locale={locale}
          />
        </div>
      </div>
    </div>
  )
}

export default ContactStoreInfoContent
